<ng-container *transloco="let t; read: 'ime.manufacturing.item-log'">
  <form>
    <div class="modal-header d-print-none bg-white p-3" ngxModalDraggable>
      <h4 class="modal-title" *ngIf="mode == 'add'">{{t('Töö lisamine')}}</h4>
      <h4 class="modal-title" *ngIf="mode == 'edit'">{{t('Töö muutmine')}}</h4>
      <button type="button" class="btn btn-success me-1 ms-auto" (click)="save()">{{t('Save')}}</button>
      <button type="button" class="btn btn-danger me-1 ms-0" *ngIf="mode == 'edit'" (click)="remove()">{{t('Delete')}}</button>
      <button type="button" class="btn-close ms-0" aria-label="Close" (click)="bsModalRef.dismiss()">
      </button>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col">
          <div class="form-group row">
            <label class="col-2 col-form-label">Staatus</label>
            <div class="col-sm-8 my-auto">
              <mes-web-classificator-value-select [entityId]="log.StatusClv"
                                                  (entityIdChange)="log.StatusClv = $event"
                                                  name="itemStatus" id="itemStatus"
                                                  [items]="classificatorValueService.getAll$ | async | where: 'ClassificatorId': statusCl"
                                                  [allowAdd]="false"></mes-web-classificator-value-select>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group row">
            <label class="col-2 col-form-label" for="Start">Algus</label>
            <div class="col-sm-8 my-auto">
              <app-date-time-picker [(ngModel)]="log.Start" id="Start" name="Start"></app-date-time-picker>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group row">
            <label class="col-2 col-form-label" for="End">Lõpp</label>
            <div class="col-sm-8 my-auto">
              <app-date-time-picker [(ngModel)]="log.End" id="End" name="End"></app-date-time-picker>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group row">
            <label class="col-2 col-form-label" for="AssignedTo">Suunatud</label>
            <div class="col-sm-8 my-auto">
              <mes-user-select [entityId]="log.AssignedTo" (entityIdChange)="log.AssignedTo = $event" id="AssignedTo" [items$]="usersQuery.getAll$" [allowAdd]="false" [name]="'AssignedTo'"></mes-user-select>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group row">
            <label class="col-2 col-form-label">Kirjeldus</label>
            <div class="col-sm-8 my-auto">
              <textarea id="Description" name="Description" class="form-control form-control-sm" rows="1" [(ngModel)]="log.Description" autosize></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group row">
            <label class="col-2 col-form-label">Sisu</label>
            <div class="col-sm-8 my-auto">
              <textarea id="Content" name="Content" class="form-control form-control-sm" rows="1" [(ngModel)]="log.Content" autosize></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-container>
